import i18next from "i18next";
import { createI18nStore } from "svelte-i18next";
import resources from "virtual:i18next-loader";
import LanguageDetector from "i18next-browser-languagedetector";
import {
  defaultLanguage,
  defaultNamespace,
  namespaces,
  supportedLanugages
} from "@/helpers/localization";

i18next.use(LanguageDetector).init({
  resources,
  supportedLngs: supportedLanugages,
  fallbackLng: defaultLanguage,
  ns: namespaces,
  defaultNS: defaultNamespace,
  detection: { order: ["htmlTag"] }
});

const i18n = createI18nStore(i18next);
export default i18n;
